export const VoicemailsTestIds = {
  CALLBACK: 'telephony-voicemails.callback-button',
  DELETE: 'telephony-voicemails.delete-button',
  MARK_ALL_READ: 'telephony-voicemails.mark-all-read-button',
};
